<template>
    <div>
        <v-toolbar dense>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="openNewDialog">Pridať</v-btn>
        </v-toolbar>

        <v-list>
            <v-list-item
                v-for="quote in quotes"
                :key="quote.id"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ quote.name }} </v-list-item-title>
                    <v-list-item-subtitle>{{ quote.organization }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ quote.position }}</v-list-item-subtitle>
                    <v-list-item-content>{{ quote.text }}</v-list-item-content>
                </v-list-item-content>

                <v-list-item-action>
                    <div class="d-flex">
                        <v-icon @click.stop="openEditDialog(quote)">mdi-pencil</v-icon>
                        <v-icon @click.stop="deleteQuote(quote)" class="ml-2">mdi-delete</v-icon>
                    </div>
                </v-list-item-action>
            </v-list-item>
        </v-list>

        <form-dialog
            v-model="dialog.open"
            :title="dialog.title"
            @save="saveModel"
        >
            <v-text-field
                v-model="dialog.model.name"
                label="Meno *"
                :errorMessages="dialog.validationErrors.name"
            ></v-text-field>
            <v-text-field
                v-model="dialog.model.organization"
                label="Organizácia"
                :errorMessages="dialog.validationErrors.organization"
            ></v-text-field>
            <v-text-field
                v-model="dialog.model.position"
                label="Pozícia"
                :errorMessages="dialog.validationErrors.position"
            ></v-text-field>
            <v-textarea
                v-model="dialog.model.text"
                label="Citát *"
                :errorMessages="dialog.validationErrors.text"
            ></v-textarea>
        </form-dialog>
    </div>
</template>

<script>
import Vue from 'vue'
import { WebQuoteService } from '@/services/api/webQuote.service'
import FormDialog from '@/components/FormDialog'

export default Vue.extend({
  components: {
    FormDialog
  },

  data () {
    return {
      quotes: [],
      dialog: {
        open: false,
        title: '',
        model: {},
        method: '',
        validationErrors: {}
      }
    }
  },

  methods: {
    init () {
      this.initQuotesList()
    },
    async initQuotesList () {
      const res = await WebQuoteService.list()
      this.quotes = res.data
    },
    async saveModel () {
      try {
        await WebQuoteService[this.dialog.method](this.dialog.model)
        await this.initQuotesList()
        this.dialog.open = false
      } catch (e) {
        if (e instanceof ValidationError) {
          this.dialog.validationErrors = e.errors
        } else {
          throw e
        }
      }
    },
    openNewDialog () {
      this.dialog = {
        open: true,
        title: 'Nový citát',
        model: {},
        method: 'create',
        validationErrors: {}
      }
    },
    openEditDialog (quote) {
      this.dialog = {
        open: true,
        title: 'Úprava citátu',
        model: { ...quote },
        method: 'update',
        validationErrors: {}
      }
    },
    async deleteQuote (quote) {
      WebQuoteService.delete(quote)
      await this.initQuotesList()
    }
  },

  created () {
    this.init()
  }
})
</script>
